module.exports = __webpack_public_path__ + "img/default.6115fd2b.svg";